import {useMemo} from 'react'

import {useGetSuggestedOnboardingUsersQuery} from '#/state/queries/trending/useGetSuggestedOnboardingUsersQuery'
import {type GoalStepResults} from '#/screens/Onboarding/state'

export function useSuggestedOnboardingUsers(goalStepResults: GoalStepResults) {
  const curated = useGetSuggestedOnboardingUsersQuery({
    accountType: goalStepResults.accountType,
    country: goalStepResults.country,
    learningStage: goalStepResults.learningStage,
    topics: goalStepResults.topics,
    familyStages: goalStepResults.familyStages,
    parentTopics: goalStepResults.parentTopics,
    childTopics: goalStepResults.childTopics,
    creatorRole: goalStepResults.creatorRole,
    audience: goalStepResults.audience,
    orgType: goalStepResults.orgType,
  })

  return useMemo(
    () => ({
      data: curated.data,
      isLoading: curated.isLoading,
      error: curated.error,
      isRefetching: curated.isRefetching,
      refetch: curated.refetch,
    }),
    [curated],
  )
}
